import { Html } from "@eusoft/webapp-jsx/components/Html";
import { formatText } from "@eusoft/webapp-ui/utils/Format";
import snarkdown from 'snarkdown';
import type { ComponentStyle } from "@eusoft/webapp-core/abstraction/IComponentOptions";
import type { LocalString } from "@eusoft/webapp-ui/types";

interface IMessageOptions {
    content: LocalString;
    style?: ComponentStyle;
    linkTarget?: string;
}


export function MarkDown(options: IMessageOptions) {

    function sanitize(text: string, target: string) {

        if (target) {
            const el = document.createElement("div");

            el.innerHTML = snarkdown(text);

            for (const link of el.querySelectorAll("a"))
                link.target = target;

            return el.innerHTML;
        }

        return snarkdown(text);
    }



    return <Html src={sanitize(formatText(options.content) as string, options.linkTarget)}/>
}